<template>
  <div :class="_class">
    <ten-select-box
      v-bind.sync="_leftProps"
      ref="leftBox"
    />
    <ten-action v-bind.sync="_actionProps" />
    <ten-select-box
      v-bind.sync="_rightProps"
      ref="rightBox"
    />
  </div>
</template>

<script>
import TenAction from './action';
import TenSelectBox from './selectBox';

const name = 'ten-transfer';

export default {
  name,
  components: {
    TenAction,
    TenSelectBox,
  },
  props: {
    /**
     * @model
     * 穿梭框的值，既右边列表的 keys
     */
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * 数据源列表
     */
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * 默认穿梭框的值
     */
    defaultValue: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否可以对目标列表拖动排序
     */
    draggable: Boolean,
    /**
     * 标题列表
     */
    titles: {
      type: Array,
      default() {
        return ['源列表', '目的列表'];
      },
    },
    /**
     * 总数单位
     */
    unit: {
      type: String,
      default: '条',
    },
    /**
     * 是否使用搜索框
     */
    filterable: {
      type: Boolean,
      default: false,
    },
    /**
     * 选中项
     */
    selectedKeys: {
      type: Array,
      default() {
        return [[], []];
      },
    },
    /**
     * 默认选中项
     */
    defaultSelectedKeys: {
      type: Array,
      default() {
        return [[], []];
      },
    },
    /**
     * 自定义选项列表框 props
     */
    boxProps: {
      type: [Object, Array],
      default: () => ({}),
    },
    /**
     * @ignore
     */
    onSelectChange: Function,
    /**
     * @ignore
     */
    onSelectedChange: Function,
  },
  data() {
    return {
      prefixClassName: name,
      searchValues: ['', ''],
    };
  },
  computed: {
    _class() {
      return [`${name}`];
    },
    _boxProps() {
      return Array.isArray(this.boxProps) ? this.boxProps : [this.boxProps, this.boxProps];
    },
    _rightData() {
      return this.value.map(key => this.data.find(item => item.key === key)).filter(v => v);
    },
    _leftData() {
      return this.data.filter(item => this.value.indexOf(item.key) === -1);
    },
    _leftProps() {
      return {
        disabled: this.disabled,
        prefixClass: name,
        unit: this.unit,
        filterable: this.filterable,

        index: 0,
        data: this._leftData,
        selectedKeys: this.selectedKeys[0],
        title: this.titles[0],
        searchValue: this.searchValues[0],
        boxProps: this._boxProps[0],

        onSelectedChange: this.onBoxSelectedChange,
        onSearch: this.onSearch,
      };
    },
    _rightProps() {
      return {
        draggable: this.draggable,
        onDataChange: this.onRightDataChange,

        disabled: this.disabled,
        prefixClass: name,
        unit: this.unit,
        filterable: this.filterable,

        index: 1,
        data: this._rightData,
        selectedKeys: this.selectedKeys[1],
        title: this.titles[1],
        searchValue: this.searchValues[1],
        boxProps: this._boxProps[1],

        onSelectedChange: this.onBoxSelectedChange,
        onSearch: this.onSearch,
      };
    },
    _actionProps() {
      return {
        disabled: this.disabled,
        prefixClass: name,
        selectedKeys: this.selectedKeys,
        onAction: this.onAction,
      };
    },
  },
  methods: {
    getSelectBox(index) {
      return index === 0 ? this.$refs.leftBox : this.$refs.rightBox;
    },
    changeSelectedKeys(selectedKeys) {
      /**
       * 选中项发生变化
       * @param selectedKeys 选中项
       */
      this.$emit('update:selectedKeys', selectedKeys);
      this.onSelectedChange && this.onSelectedChange(selectedKeys);
      this.onSelectChange && this.onSelectChange(selectedKeys);
    },
    changeValue(value, ...args) {
      /**
       * 穿梭框的值发生变化
       * @param value 选中值
       */
      this.$emit('change', value, ...args);
      this.onChange && this.onChange(value, ...args);
    },
    getData() {
      const d = this.data;

      return [
        d.filter(item => !(this.value || []).some(key => key === item.key)),
        d.filter(item => (this.value || []).some(key => key === item.key)),
      ];
    },
    onSearch(index, e) {
      this.searchValues[index] = this.$set(this.searchValues, index, e.target.value);
    },
    onBoxSelectedChange(index, boxSelectedKeys) {
      const selectedKeys = [
        [...this.selectedKeys[0]],
        [...this.selectedKeys[1]],
      ];
      selectedKeys[index] = boxSelectedKeys;
      this.changeSelectedKeys(selectedKeys);
    },
    onAction(mode) {
      if (this.disabled) return;

      const index = mode === 'join' ? 0 : 1;
      const selectBox = this.getSelectBox(index);
      const moveKeys = selectBox._listSelectedKey;
      const selectedKeys = [
        [...this.selectedKeys[0]],
        [...this.selectedKeys[1]],
      ];
      let value;

      if (mode === 'join') {
        value = [...this.value, ...moveKeys];
        selectedKeys[0] = selectedKeys[0].filter(key => moveKeys.indexOf(key) === -1);
      } else {
        value = this.value.filter(key => moveKeys.indexOf(key) === -1);
        selectedKeys[1] = selectedKeys[1].filter(key => moveKeys.indexOf(key) === -1);
      }
      this.changeValue(value);
      this.changeSelectedKeys(selectedKeys);
    },
    onRightDataChange(rightData) {
      const value = rightData.map(item => item.key);
      this.changeValue(value);
    },
  },
};
</script>
